module.exports = __webpack_public_path__ + "static/media/wrinkles_periocular.e1e0b84b.svg";